<template>
  <div class="certification">
    <div class="certification-container">
      <div class="title"></div>
      <div class="image-container">
        <div class="item">
          <el-image
            :src="
              require('../../../../assets/moblie/images/certification1.png')
            "
            class="certification-image"
            :preview-src-list="imageList"
          />
          <div class="item-title">澳门上市证明</div>
        </div>
        <div class="item">
          <el-image
            :src="
              require('../../../../assets/moblie/images/certification2.png')
            "
            class="certification-image"
            :preview-src-list="imageList"
          />
          <div class="item-title">香港上市证明</div>
        </div>
        <div class="item">
          <el-image
            :src="
              require('../../../../assets/moblie/images/certification3.png')
            "
            class="certification-image"
            :preview-src-list="imageList"
          />
          <div class="item-title">台湾上市证明</div>
        </div>
        <div class="item">
          <el-image
            :src="
              require('../../../../assets/moblie/images/certification4.png')
            "
            class="certification-image"
            :preview-src-list="imageList"
          />
          <div class="item-title">乐托品出口证</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListingCertification",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {
      imageList: [
        require("../../../../assets/moblie/images/certification1.png"),
        require("../../../../assets/moblie/images/certification2.png"),
        require("../../../../assets/moblie/images/certification3.png"),
        require("../../../../assets/moblie/images/certification4.png")
      ]
    };
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.certification {
  height: 100%;
  background-color: rgb(72, 173, 241);
  padding: 15px 20px;
  overflow: auto;
  &-container {
    background-color: #fff;
    border-radius: 14px;
    min-height: 100%;
    overflow: auto;
    padding: 15px 15px;
    .title {
      background-image: url("../../../../assets/moblie/images/certificationtitle.png");
      background-size: 100% 100%;
      width: 80%;
      height: 1.5rem;
      margin: 0 auto;
    }
    .image-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .item {
      width: 41%;
      margin: 10px;
      .certification-image {
        width: 100%;
        height: 100%;
      }
      &-title {
        background-color: rgb(46, 119, 196);
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        margin-top: 10px;
        padding: 5px 0;
        box-sizing: border-box;
      }
    }
  }
}
</style>
